// extracted by mini-css-extract-plugin
export default {"tableContainer":"Companies_tableContainer__iBoSL"};